// extracted by mini-css-extract-plugin
export default {"container_with_pointer":"ManageWarnings_container_with_pointer__zHYC4"};